import OapScroller from './code/Scripts/components/OapScroller.vue';

export default {
  components: {
    OapScroller,
  },
};
